import "./paymentResultPage.css";
import AppContext from "../../AppContext";
import { useParams, Navigate, Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  checkPaymentWithCloudFunction,
  getPayment,
  saveUserData,
  markGroupReceiptAsPaid, 
  getGroupReceiptIdByPayerReceiptId
} from "../../db/firebaseMethods";
import LoadingBlock from "../../components/organisms/loadingBlock/loadingBlock";
import Button from "@mui/material/Button";

export default function PaymentResultPage() {
  const { setCentralState, user, refreshUserData } =
    React.useContext(AppContext);

  const [paymentVerificationResult, setPaymentVerificationResult] =
    useState("");

    useEffect(() => {
        const allParams = window.location.search;
        const paramCouples = allParams.split("?");

        let queryParamsObject = {};
        paramCouples.forEach((couple) => {
          const [key, value] = couple.split("=");
          if (key && value) queryParamsObject[key] = value;
        });

        const { firebase_receipt_id, payment_token, zero_payment } = queryParamsObject;

        if (firebase_receipt_id === "error") {
          setPaymentVerificationResult("Ödeme Başarısız.");
        } else if (firebase_receipt_id && payment_token) {
          controlPayment(payment_token, {
            zero_payment: false,
            firebase_receipt_id,   // ← bunu ekle, controlPayment içinde kullanacağız
          });
        } else if (firebase_receipt_id && zero_payment) {
          controlPayment("", { zero_payment: true, firebase_receipt_id });
        }
      }, []);

  const controlPayment = async (payment_token, zero_payment_object) => {
    const result = await checkPaymentWithCloudFunction(
      payment_token,
      zero_payment_object
    );

    await refreshUserData();
    setPaymentVerificationResult(result);
  }

  if (!paymentVerificationResult)
    return (
      <div className="payment-result-page-container">
        {"Son kontrolleri yapıyoruz... Lütfen bu ekranda bekleyiniz..."}
        <LoadingBlock />
      </div>
    );
  else {
    return (
      <div className="payment-result-page-container">
        {paymentVerificationResult}

        <Link to="/profile" style={{ marginTop: 20 }}>
          <Button variant="contained" color="secondary">
            PPROFİL SAYFANIZA DÖNMEK İÇİN TIKLAYINIZ
          </Button>
        </Link>
      </div>
    );
  }
}
